// React
import React from 'react';

// Refine
import { useTranslation } from '@refinedev/core';

// Mantine
import { Button, Tooltip, useComputedColorScheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

// Icons
import { IconUpload } from '@tabler/icons-react';
import { getOutlineControlProps } from 'utils/buttonUtils';

import { FamilyMedicineUploadModal } from 'pages/claims/components/ClaimToolBarComponents/FamilyMedicineUploadModal';

interface InternalUploadDataButtonProps {
  disabled?: boolean;
  variant?: 'subtle' | 'create';
}

export const InternalUploadDataButton: React.FC<
  InternalUploadDataButtonProps
> = ({ disabled = false, variant = 'subtle' }) => {
  const computedColorScheme = useComputedColorScheme('dark');
  const [opened, { open, close }] = useDisclosure(false);
  const { translate } = useTranslation();
  const isCreateVariant = variant === 'create';

  return (
    <>
      <Tooltip
        label={translate('pages:claims.uploadDataTooltip')}
        position="top"
      >
        <Button
          onClick={open}
          disabled={disabled}
          size={isCreateVariant ? 'sm' : 'xs'}
          p="0.313rem"
          radius={isCreateVariant ? 'md' : undefined}
          aria-label={translate('pages:claims.uploadDataTooltip')}
          data-testid="upload-family-medicine-button"
          data-variant={isCreateVariant ? 'create' : undefined}
          {...(isCreateVariant
            ? getOutlineControlProps(computedColorScheme, disabled)
            : { variant: 'subtle' as const })}
        >
          <IconUpload
            color={computedColorScheme === 'dark' ? 'white' : 'black'}
          />
        </Button>
      </Tooltip>
      <FamilyMedicineUploadModal close={close} opened={opened} />
    </>
  );
};
